import { ErrorBoundary } from 'react-error-boundary';

import { AppCard, AppCardSkeleton } from 'src/widgets/AppCard';
import { withSuspense } from 'src/hoc';

import { AppProtectionContextProvider, useAppProtection, mapAppToCardData, type MappableApp } from '../model';

const AppCardData = ({ app }: { app: MappableApp }) => {
  const { products, certificateBadges, unclaimedDetectedProduct } = useAppProtection();

  return <AppCard data={{ ...mapAppToCardData(app), products, certificateBadges, unclaimedDetectedProduct }} />;
};

const AppCardWithProtections = withSuspense(
  ({ app }: { app: MappableApp }) => (
    <ErrorBoundary fallback={<AppCard data={mapAppToCardData(app)} />}>
      <AppProtectionContextProvider app={app}>
        <AppCardData app={app} />
      </AppProtectionContextProvider>
    </ErrorBoundary>
  ),
  AppCardSkeleton,
);

export { AppCardWithProtections };
